import { render, staticRenderFns } from "./TableCodPostales.vue?vue&type=template&id=6002c533&scoped=true&"
import script from "./TableCodPostales.vue?vue&type=script&lang=js&"
export * from "./TableCodPostales.vue?vue&type=script&lang=js&"
import style0 from "./TableCodPostales.vue?vue&type=style&index=0&id=6002c533&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6002c533",
  null
  
)

export default component.exports